// Ses efektleri için utility
// Doğru/Yanlış/Uyarı/Başarı sesleri

// Web Audio API kullanarak basit ses efektleri
class SoundEffects {
  constructor() {
    this.audioContext = null;
    this.enabled = true;
    this.volume = 0.5;
  }

  init() {
    if (!this.audioContext) {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
    }
    return this.audioContext;
  }

  setEnabled(enabled) {
    this.enabled = enabled;
  }

  setVolume(volume) {
    this.volume = Math.max(0, Math.min(1, volume));
  }

  // Basit bir bip sesi oluştur
  playTone(frequency, duration, type = 'sine') {
    if (!this.enabled) return;
    
    try {
      const ctx = this.init();
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      
      oscillator.frequency.value = frequency;
      oscillator.type = type;
      
      gainNode.gain.setValueAtTime(this.volume * 0.3, ctx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + duration);
      
      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + duration);
    } catch (e) {
      console.log('Sound effect error:', e);
    }
  }

  // Doğru cevap sesi - Yükselen melodi
  playCorrect() {
    if (!this.enabled) return;
    
    try {
      const ctx = this.init();
      const notes = [523.25, 659.25, 783.99]; // C5, E5, G5
      
      notes.forEach((freq, i) => {
        const oscillator = ctx.createOscillator();
        const gainNode = ctx.createGain();
        
        oscillator.connect(gainNode);
        gainNode.connect(ctx.destination);
        
        oscillator.frequency.value = freq;
        oscillator.type = 'sine';
        
        const startTime = ctx.currentTime + i * 0.1;
        gainNode.gain.setValueAtTime(this.volume * 0.2, startTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + 0.2);
        
        oscillator.start(startTime);
        oscillator.stop(startTime + 0.2);
      });
    } catch (e) {
      console.log('Sound effect error:', e);
    }
  }

  // Yanlış cevap sesi - Düşük bip
  playWrong() {
    if (!this.enabled) return;
    
    try {
      const ctx = this.init();
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      
      oscillator.frequency.value = 200;
      oscillator.type = 'sawtooth';
      
      gainNode.gain.setValueAtTime(this.volume * 0.15, ctx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.3);
      
      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + 0.3);
    } catch (e) {
      console.log('Sound effect error:', e);
    }
  }

  // Uyarı sesi - İki kısa bip
  playWarning() {
    if (!this.enabled) return;
    
    try {
      const ctx = this.init();
      
      [0, 0.2].forEach((delay) => {
        const oscillator = ctx.createOscillator();
        const gainNode = ctx.createGain();
        
        oscillator.connect(gainNode);
        gainNode.connect(ctx.destination);
        
        oscillator.frequency.value = 800;
        oscillator.type = 'square';
        
        const startTime = ctx.currentTime + delay;
        gainNode.gain.setValueAtTime(this.volume * 0.15, startTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + 0.1);
        
        oscillator.start(startTime);
        oscillator.stop(startTime + 0.1);
      });
    } catch (e) {
      console.log('Sound effect error:', e);
    }
  }

  // Başarı sesi - Fanfar tarzı
  playSuccess() {
    if (!this.enabled) return;
    
    try {
      const ctx = this.init();
      const notes = [523.25, 659.25, 783.99, 1046.50]; // C5, E5, G5, C6
      
      notes.forEach((freq, i) => {
        const oscillator = ctx.createOscillator();
        const gainNode = ctx.createGain();
        
        oscillator.connect(gainNode);
        gainNode.connect(ctx.destination);
        
        oscillator.frequency.value = freq;
        oscillator.type = 'sine';
        
        const startTime = ctx.currentTime + i * 0.15;
        const duration = i === notes.length - 1 ? 0.4 : 0.15;
        
        gainNode.gain.setValueAtTime(this.volume * 0.25, startTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
        
        oscillator.start(startTime);
        oscillator.stop(startTime + duration);
      });
    } catch (e) {
      console.log('Sound effect error:', e);
    }
  }

  // Tıklama sesi - Kısa bip
  playClick() {
    if (!this.enabled) return;
    this.playTone(1000, 0.05, 'sine');
  }

  // Seviye atlama sesi
  playLevelUp() {
    if (!this.enabled) return;
    
    try {
      const ctx = this.init();
      const notes = [261.63, 329.63, 392.00, 523.25, 659.25, 783.99]; // C4 to G5
      
      notes.forEach((freq, i) => {
        const oscillator = ctx.createOscillator();
        const gainNode = ctx.createGain();
        
        oscillator.connect(gainNode);
        gainNode.connect(ctx.destination);
        
        oscillator.frequency.value = freq;
        oscillator.type = 'sine';
        
        const startTime = ctx.currentTime + i * 0.08;
        gainNode.gain.setValueAtTime(this.volume * 0.2, startTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + 0.15);
        
        oscillator.start(startTime);
        oscillator.stop(startTime + 0.15);
      });
    } catch (e) {
      console.log('Sound effect error:', e);
    }
  }

  // Mil kazanma sesi
  playMiles() {
    if (!this.enabled) return;
    
    try {
      const ctx = this.init();
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      
      oscillator.frequency.setValueAtTime(400, ctx.currentTime);
      oscillator.frequency.exponentialRampToValueAtTime(800, ctx.currentTime + 0.1);
      oscillator.type = 'sine';
      
      gainNode.gain.setValueAtTime(this.volume * 0.15, ctx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.15);
      
      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + 0.15);
    } catch (e) {
      console.log('Sound effect error:', e);
    }
  }

  // Ders başlama sesi
  playStart() {
    if (!this.enabled) return;
    
    try {
      const ctx = this.init();
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      
      oscillator.frequency.value = 600;
      oscillator.type = 'sine';
      
      gainNode.gain.setValueAtTime(this.volume * 0.2, ctx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.2);
      
      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + 0.2);
    } catch (e) {
      console.log('Sound effect error:', e);
    }
  }
}

// Singleton instance
const soundEffects = new SoundEffects();

export default soundEffects;

// React hook for sound effects
export const useSoundEffects = () => {
  return {
    playCorrect: () => soundEffects.playCorrect(),
    playWrong: () => soundEffects.playWrong(),
    playWarning: () => soundEffects.playWarning(),
    playSuccess: () => soundEffects.playSuccess(),
    playClick: () => soundEffects.playClick(),
    playLevelUp: () => soundEffects.playLevelUp(),
    playMiles: () => soundEffects.playMiles(),
    playStart: () => soundEffects.playStart(),
    setEnabled: (enabled) => soundEffects.setEnabled(enabled),
    setVolume: (volume) => soundEffects.setVolume(volume)
  };
};
